import {Injectable} from "@angular/core";
import {Clipboard} from "@angular/cdk/clipboard";

@Injectable()
export class ClipboardService {
    constructor(
        private clipboard: Clipboard,
    ) { }

    /**
     * Copy the text to the clipboard and show a snackbar with a success message
     * @param {string} text - The text to copy to the clipboard.
     */
    copyToClipboard(text: string) {
        this.clipboard.copy(text);
    }
}
